import PropTypes from 'prop-types';

// Props pour fonction getLogo
export const LogoPropTypes = {
  success: PropTypes.bool.isRequired,
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])])
};

// Props pour fonction getCompanyFiles et getClientFiles
const FileType = PropTypes.shape({
  app_chain: PropTypes.string,
  company_name: PropTypes.string,
  created_at: PropTypes.string,
  date: PropTypes.string,
  extension: PropTypes.string,
  file_type: PropTypes.number,
  file_type_code: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  file_type_id: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  file_type_name: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  filename: PropTypes.string,
  folder_virtual: PropTypes.string,
  foreign_id: PropTypes.number,
  id: PropTypes.number,
  is_client: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_company: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_resource: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_site: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_validation_required_partner: PropTypes.number,
  is_validation_required_resource: PropTypes.number,
  name: PropTypes.string,
  path: PropTypes.string,
  status: PropTypes.string,
  status_id: PropTypes.number,
  type: PropTypes.string,
  updated_at: PropTypes.string,
  url: PropTypes.string,
  validation_text: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  viewed_at: PropTypes.string
});

export const CompanyFilesPropTypes = {
  success: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(FileType).isRequired
};

export const ClientFilesPropTypes = {
  success: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(FileType).isRequired
};

// Props pour fonction getResourceFiles et getUserResourceFiles
const FilePropTypes = PropTypes.shape({
  app_chain: PropTypes.string,
  created_at: PropTypes.string,
  date: PropTypes.string,
  extension: PropTypes.string,
  file_type: PropTypes.number,
  file_type_code: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf([null])]),
  file_type_id: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  file_type_name: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  filename: PropTypes.string,
  folder_virtual: PropTypes.string,
  foreign_id: PropTypes.number,
  id: PropTypes.number,
  is_client: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_company: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_resource: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_site: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  is_validation_required_partner: PropTypes.number,
  is_validation_required_resource: PropTypes.number,
  name: PropTypes.string,
  path: PropTypes.string,
  status: PropTypes.string,
  status_id: PropTypes.number,
  type: PropTypes.string,
  updated_at: PropTypes.string,
  url: PropTypes.string,
  validation_text: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])])
});

export const UserResourceFilesPropTypes = {
  success: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(FilePropTypes).isRequired
};

export const AgentResourceFilesPropTypes = {
  success: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(FilePropTypes).isRequired
};
